import React from "react";
import {Button, Col, Row, Steps} from "antd";
import PropTypes from 'prop-types';

import ErrorBoundary from "./ErrorBoundary";
import WhiteBackgroundWrapper from "./WhiteBackgroundWrapper";

import './StepsWrapper.less'

const StepsWrapper = (props) => {
    const {steps, currentStep, handleFinish, goBack, submitText, isLoading} = props;
    const totalSteps = steps.length;

    const headerColSize = {
        xs: {span: 24, offset: 0},
        sm: {span: 18, offset: 3}
    };

    const getButtons = (currentStep) => {
        let result;

        switch (currentStep) {
            case 0:     //first step
                result =
                    <div className="steps-single-button">
                        <Button
                            form={steps[currentStep].form}
                            htmlType="submit"
                            type="primary"
                            size="large"
                            loading={isLoading}
                        >
                            {!goBack ? "Submit" : "Next"}
                        </Button>
                    </div>
                ;
                break;
            case totalSteps - 1:    //last step
                result =
                    <div className="steps-multi-button">
                        {!goBack ? <div></div> :
                        <Button type="default" htmlType="button" size="large" onClick={goBack}>
                            Back
                        </Button>
                        }
                        <Button
                            type="primary"
                            size="large"
                            className="steps-multi-button-next-btn"
                            onClick={handleFinish}
                            loading={isLoading}
                        >
                            {submitText}
                        </Button>
                    </div>
                ;
                break;
            default:    //middle steps
                result =
                    <div className="steps-multi-button">
                        {!goBack ? <div></div> :
                        <Button type="default" htmlType="button" size="large" onClick={goBack}>
                            Back
                        </Button>
                        }
                        <Button
                            type="primary"
                            form={steps[currentStep].form}
                            htmlType="submit"
                            className="steps-multi-button-next-btn"
                            size="large"
                            loading={isLoading}
                        >
                            {!goBack ? "Submit" : "Next"}
                        </Button>
                    </div>
                ;
                break;
        }

        return result;
    };

    return <ErrorBoundary>
        <WhiteBackgroundWrapper>
            <Row>
                <Col {...headerColSize}>
                    <Steps current={currentStep} className="steps-header" items={steps} />
                    <div>{steps[currentStep].content}</div>
                </Col>
            </Row>
            <Row className="steps-button-row">
                <Col {...headerColSize}>
                    {getButtons(currentStep)}
                </Col>
            </Row>
        </WhiteBackgroundWrapper>
    </ErrorBoundary>
}

export default StepsWrapper;

StepsWrapper.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.object).isRequired,
    goBack: PropTypes.func,
    isLoading: PropTypes.bool.isRequired,
    currentStep: PropTypes.number.isRequired,
    handleFinish: PropTypes.func.isRequired,
    submitText: PropTypes.string,
};

StepsWrapper.defaultProps = {
    submitText: 'Submit',
}
